import {useEffect, useCallback} from 'react';

import dayjs from 'dayjs';

import {defaultValues as officeInformationDefaultValues} from '../../../EmmaiDentalOfficeForm/helpers/defaultValues';
import deserializeDentalOffice from '../../../EmmaiDentalOfficeForm/helpers/deserializeDentalOffice';
import {defaultValues as practitionerActivityDefaultValues} from '../../../EmmaiPractitionerActivityInformationForm/helpers/defaultValues';
import deserializePractitionerActivity from '../../../EmmaiPractitionerActivityInformationForm/helpers/deserializePractitionerActivity';

export default function useMonthlyRestitutionFormData({emmaiData, formattedEmmaiRestitutionSelectedDate, selectedProject, methods}) {
  const getLastMonthFromCurrentFormattedDate = useCallback(() => {
    const currentDate = dayjs(formattedEmmaiRestitutionSelectedDate);
    const lastMonth = currentDate.subtract(1, 'month');
    return lastMonth.format('YYYY-MM-DD');
  }, [formattedEmmaiRestitutionSelectedDate]);

  const getInitialOfficeInformation = useCallback(() => {
    if (!emmaiData?.info) return null;

    // 1/ Existing month
    const currentMonth = emmaiData.info.find(i => i.period === formattedEmmaiRestitutionSelectedDate);
    if (currentMonth) return deserializeDentalOffice(currentMonth);

    // 2/ Previous month
    const lastMonthDate = getLastMonthFromCurrentFormattedDate();
    const previousMonth = emmaiData.info.find(i => i.period === lastMonthDate);
    if (previousMonth) return deserializeDentalOffice(previousMonth);

    // 3/ Default values
    return {
      ...officeInformationDefaultValues,
      siren: selectedProject?.siren,
      period: formattedEmmaiRestitutionSelectedDate
    };
  }, [emmaiData, formattedEmmaiRestitutionSelectedDate, selectedProject, getLastMonthFromCurrentFormattedDate]);

  useEffect(() => {
    if (!emmaiData?.info || !formattedEmmaiRestitutionSelectedDate || !selectedProject) return;

    // PRACTITIONER ACTIVITY INITIALIZE
    const practitionerIds = (emmaiData.practitioners || []).map(p => p.practitioner_id);

    const practitionerActivity = practitionerIds.reduce((acc, id) => {
      const existing = emmaiData.practitioner_activities.find(a => a.period === formattedEmmaiRestitutionSelectedDate && a.practitioner_id === id);

      acc[id] = existing
        ? deserializePractitionerActivity(existing)
        : {
            ...practitionerActivityDefaultValues,
            siren: selectedProject.siren,
            period: formattedEmmaiRestitutionSelectedDate
          };

      return acc;
    }, {});

    // OFFICE DATA
    const officeInformation = getInitialOfficeInformation();

    // RESET FORM
    methods.reset({
      officeInformation,
      practitionerActivity
    });
  }, [emmaiData, selectedProject, formattedEmmaiRestitutionSelectedDate, methods, getInitialOfficeInformation]);
}
